export const SMALL_WIDTH = " @media (min-width: 480px)";
export const MEDIUM_WIDTH = "@media (min-width: 768px)";
export const RED = "#c60636";
export const GREEN = "#2c9c49";
export const BLUE = "#1a74bd";
